import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Listbox, Transition } from '@headlessui/react';
import { CheckCircleIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { ROLES } from '../utils/auth/permission-maps';
import useProfile from '../utils/auth/useProfile';

const profiles = [
  { id: 1, name: 'Mentor mode', code: ROLES.mentor },
  { id: 2, name: 'Learner mode', code: ROLES.learner },
];

export default function ProfileSwitch() {
  const { getProfile } = useProfile();
  const currentProfile = getProfile();
  const selectedProfile = profiles.find(
    profile => profile.code == currentProfile
  );
  const [selected, setSelected] = useState(
    selectedProfile ? selectedProfile : profiles[1]
  );
  const navigate = useNavigate();

  const handleProfileChange = profile => {
    setSelected(profile);
    navigate(`/profiles/${profile.code}/switch`);
  };

  return (
    <div className="top-16 mb-6">
      <Listbox value={selected} onChange={handleProfileChange}>
        <div className="relative mt-1">
          <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left border focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 text-xs shadow">
            <span className="block truncate uppercase font-semibold">
              {selected.name}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon
                className="h-4 w-4 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-gray-50 py-1 text-xs shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-xs uppercase">
              {profiles.map(profile => (
                <Listbox.Option
                  key={profile.id}
                  className={({ active }) =>
                    `relative cursor-default select-none py-2 pl-10 pr-4 ${
                      active ? 'bg-gray-100 text-gray-700' : 'text-gray-700'
                    }`
                  }
                  value={profile}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate uppercase ${
                          selected ? 'font-semibold' : 'font-normal'
                        }`}
                      >
                        {profile.name}
                      </span>
                      {selected ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-orange-400">
                          <CheckCircleIcon
                            className="h-5 w-5"
                            aria-hidden="true"
                          />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}
